import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Container } from '@mui/material';

export default function NotFound() {
  return (
    <Box minHeight="100vh" display="flex" flexDirection="column" justifyContent="center" alignItems="center" bgcolor="background.default" py={8}>
      <Container maxWidth="xs" sx={{ textAlign: 'center' }}>
        <Typography variant="h1" component="h1" fontWeight={700} color="text.primary" gutterBottom>
          404
        </Typography>
        <Typography variant="h4" component="h2" fontWeight={700} color="text.primary" gutterBottom>
          Page non trouvée
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          Désolé, nous n'avons pas trouvé la page que vous recherchez.
        </Typography>
        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          color="primary"
          size="large"
          sx={{ mt: 4, borderRadius: 2, boxShadow: 2 }}
        >
          Retour à l'accueil
        </Button>
        <Box mt={8} display="flex" justifyContent="center">
          <img
            src="/football-field.svg"
            alt="Terrain de football"
            style={{ height: 180, opacity: 0.18 }}
          />
        </Box>
      </Container>
    </Box>
  );
}
